import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {map} from "rxjs/operators";
import { Convocation } from "../../models/preregistration";

@Injectable({
    providedIn: "root"
})
export class ConvocationService {

    constructor (private http: HttpClient) { }

    list (page?: number, term?: string, studentConfirmed?: string): Observable<Array<Convocation>> {
        let params = new HttpParams();

        if (term) {
            params = params.set(
                "term",
                `${term}`
            );
        }

        if (page) {
            params = params.set(
                "page",
                `${page}`
            );
        }

        if (studentConfirmed !== undefined && studentConfirmed !== "all") {
            params = params.set(
                "student_confirmed",
                studentConfirmed
            );
        }

        return this.http.get<Array<Convocation>>(
            `${environment.baseApiUrl}/convocations/`,
            {params}
        ).
            pipe(map((res) => res.map((d) => new Convocation(d))));
    }

    count (term?: string, studentConfirmed?: string): Observable<number> {
        let params = new HttpParams();

        if (term) {
            params = params.set(
                "term",
                `${term}`
            );
        }

        if (studentConfirmed !== undefined && studentConfirmed !== "all") {
            params = params.set(
                "student_confirmed",
                studentConfirmed
            );
        }

        return this.http.get<number>(
            `${environment.baseApiUrl}/convocations/count/`,
            {params}
        );
    }

    countByStatus (term?: string): Observable<{total: number, confirmed: number, not_confirmed: number, no_exam: number}> {
        let params = new HttpParams();

        if (term) {
            params = params.set(
                "term",
                `${term}`
            );
        }

        return this.http.get<{total: number, confirmed: number, not_confirmed: number, no_exam: number}>(
            `${environment.baseApiUrl}/convocations/count_by_status/`,
            {params}
        );
    }
}
